import React from 'react'
import algoliasearch from 'algoliasearch'
import { connect } from 'react-redux'
import { Configure, InstantSearch } from 'react-instantsearch-dom'

import { FETCH_USER_WITH_PERMISSIONS } from 'mednet-cns/src/reducers/user'
import { getRequest } from 'mednet-cns/src/api/v1'
import { nodeApiSearchItems } from 'mednet-util/src/search'

import UserTagSelect from './userTagSelect'
import GeoTagSelect from './geoTagSelect'
import TopicTagSelect from './topicTagSelect'

const INDEX_SELECT_COMPONENT = {
  user: UserTagSelect,
  geo: GeoTagSelect,
}

const USER_SUBRESOURCES = ['profile.specialty', 'primaryJob.organization']

export const mapUserRowToAlgoliaHit = (user) => ({
  objectID: `${user.id}`,
  user_id: user.id,
  firstname: user.profile?.firstName,
  middlename: user.profile?.middleName,
  lastname: user.profile?.lastName,
  institution: user.primaryJob?.organization?.name,
  specialty: user.profile?.specialty?.specialty,
  picture_version: user.profile?.pictureVersion,
  _highlightResult: user._highlightResult,
})

const nodeUserSearchClient = {
  search(requests) {
    const request = requests.find(
      (aRequest) => aRequest.params.query && aRequest.params.query.length !== 0
    )

    if (!request) {
      return false
    }

    const { query, hitsPerPage } = request.params

    return nodeApiSearchItems('users', {
      query,
      limit: hitsPerPage,
      subresources: USER_SUBRESOURCES,
    }).then((data) => ({
      results: [
        {
          hits: data.items.map(mapUserRowToAlgoliaHit),
          nbHits: data.pagination.total,
          page: 0,
          nbPages: 1,
          hitsPerPage,
          exhaustiveNbHits: true,
          query,
          params: '',
          processingTimeMS: 0,
          index: request.indexName,
        },
      ],
    }))
  },
}

class TagSearch extends React.Component {
  render() {
    const { userData, isLoaded, index, hitsPerPage, ...restProps } = this.props

    // Topic tagging searches through the node API, which picks the engine
    // server-side via the topicsearchplatform flag; no browser Algolia.
    if (index === 'topic') {
      return <TopicTagSelect hitsPerPage={hitsPerPage} {...restProps} />
    }

    if (!isLoaded) {
      return null
    }

    const { algoliaApp, algoliaKey, algoliaNamespace } = userData
    const SelectComponent = INDEX_SELECT_COMPONENT[index]

    let searchClient
    if (index === 'user') {
      searchClient = nodeUserSearchClient
    } else {
      const algoliaClient = algoliasearch(algoliaApp, algoliaKey)
      searchClient = {
        search(requests) {
          const newRequests = requests.filter(
            (request) =>
              request.params.query && request.params.query.length !== 0
          )

          if (!newRequests.length) {
            return false
          }

          return algoliaClient.search(newRequests)
        },
      }
    }

    return (
      <InstantSearch
        indexName={`${algoliaNamespace}_${index}`}
        searchClient={searchClient}
      >
        <SelectComponent {...restProps} />

        <Configure highlightPreTag="<em>" highlightPostTag="</em>" />
        <Configure hitsPerPage={hitsPerPage || 5} />
      </InstantSearch>
    )
  }
}

const mapStateToProps = (state) => {
  const userRequest = getRequest(state, FETCH_USER_WITH_PERMISSIONS)

  return {
    userData: state.user.data,
    isLoaded: userRequest.isLoaded,
  }
}

export default connect(mapStateToProps)(TagSearch)
